import { render, staticRenderFns } from "./AffItem.vue?vue&type=template&id=3dd8962a&scoped=true&"
import script from "./AffItem.vue?vue&type=script&lang=js&"
export * from "./AffItem.vue?vue&type=script&lang=js&"
import style0 from "./AffItem.vue?vue&type=style&index=0&id=3dd8962a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd8962a",
  null
  
)

export default component.exports